import { render } from "./BsSideMenuView.vue?vue&type=template&id=44bd0ccc"
import script from "./BsSideMenuView.vue?vue&type=script&lang=js"
export * from "./BsSideMenuView.vue?vue&type=script&lang=js"

import "./BsSideMenuView.vue?vue&type=style&index=0&id=44bd0ccc&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__